// src/utils/IdGenerator.ts
const STORAGE_KEY = 'app_last_generated_id'

class IdGenerator {
  private lastId: number

  constructor() {
    // Load last used ID from localStorage (or start at 0)
    const stored = localStorage.getItem(STORAGE_KEY)
    this.lastId = stored ? parseInt(stored) : 0
  }

  public nextId(): number {
    let id = Date.now()

    // Ensure it's always greater than the last one used
    if (id <= this.lastId) {
      id = this.lastId + 1
    }

    this.lastId = id
    localStorage.setItem(STORAGE_KEY, id.toString())

    return id
  }
}

// Create a singleton instance
export const idGenerator = new IdGenerator()
